<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="slide-x-transition"
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :error-messages="errorMessages"
        :required="required"
        @focus="focused"
        @input="updateSelf"
        :value="content"
        :label="label"
        prepend-inner-icon="date_range"
        :disabled="disabled"
        :append-icon="clearable ? 'close' : ''"
        @click:append="handleClear"
        v-on="on"
        :rules="rules"
      ></v-text-field>
    </template>
    <v-date-picker no-title v-model="date" v-if="startInput" @input="startInput = false"></v-date-picker>
    <v-time-picker no-title v-model="time" @change="handlePick" v-if="!startInput"></v-time-picker>
  </v-menu>
</template>

<script>
export default {
  name: "DateTimeInput",
  model: {
    prop: "datetime",
    event: "input"
  },
  props: {
    label: String,
    content: String,
    errorMessages: String,
    required: Boolean,
    disabled: false,
    clearable: false,
    rules: Array
  },
  data() {
    return {
      menu: false,
      date: null,
      time: null,
      startInput: true
    };
  },
  methods: {
    handlePick() {
      this.updateSelf();
    },
    updateSelf() {
      this.menu = false;
      this.$emit("input", this.date + " " + this.time);
    },
    focused() {
      this.$emit("focused");
    },
    handleClear() {
      if (this.clearable) {
        this.$emit("input", "");
      }
    }
  },
  computed: {
    datetime: function() {
      if (this.date != null && this.time != null) {
        return this.date + " " + this.time;
      } else {
        return null;
      }
    }
  },
  watch: {
    menu: function() {
      if (!this.menu) {
        setTimeout(() => (this.startInput = true), 500);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
